/**
 * SidecarSourceContext — toggle between compiled-in sidecars and live HTTP
 * fetches.
 *
 * Default behaviour (`useBuiltins: true`) reads `BUILTIN_*_SIDECARS` from
 * `builtinSidecars.ts` synchronously — zero round-trips, calibration data
 * version-locked to the JS that consumes it. That's right for production.
 *
 * Setting `useBuiltins: false` (via the `useBuiltinSidecars` prop on
 * `<XtsViewer3D>`) makes every sidecar hook fall through to the HTTP fetch
 * against `<assetsBaseUrl>/<id>.meta.json`. That's the dev-loop mode used
 * by the playground / calibration tool: edit a JSON file in
 * `public/models/`, refresh, see the change, no bundle regeneration.
 */

import { createContext, useContext } from 'react';

export interface SidecarSourceConfig {
  /**
   * When true (default), the sidecar hooks return the compiled-in
   * BUILTIN_*_SIDECARS entry without an HTTP fetch. When false, every
   * hook always fetches from `<assetsBaseUrl>/<id>.meta.json` so live
   * edits to those JSON files are picked up on reload.
   */
  useBuiltins: boolean;
}

const DEFAULT: SidecarSourceConfig = Object.freeze({ useBuiltins: true });

export const SidecarSourceContext =
  createContext<SidecarSourceConfig>(DEFAULT);

export function useSidecarSource(): SidecarSourceConfig {
  return useContext(SidecarSourceContext);
}
